import Vue from 'vue'
import '@/plugins/skrollr'

// eslint-disable-next-line
Vue.prototype.$skrollr = skrollr.init()